import {Spine, SpineParser} from '@pixi-spine/loader-uni';
export {Spine, SpineParser};
export * from '@pixi-spine/base';
export {SkeletonBounds} from '@pixi-spine/runtime-4.1';

SpineParser.registerLoaderPlugin();
